import { Section, Tile } from "./Common";
import { dot } from "../lib/fmt";

export function dueMembersFor(data, ds) {
  return data.team.filter((m) => m.mustReport && m.active && m.createdAt.slice(0, 10) <= ds &&
    !data.leaves.some((l) => l.memberId === m.id && l.from <= ds && ds <= l.to));
}

export default function StatusSection({ data }) {
  const ds = data.date;
  const isToday = ds === data.today;
  const nowHM = data.now.slice(11, 16);
  const beforeDeadline = isToday && nowHM < data.settings.deadline;
  const due = dueMembersFor(data, ds);
  const reports = data.reports.filter((r) => r.date === ds);
  const filledIds = new Set(reports.map((r) => r.memberId));
  const done = due.filter((m) => filledIds.has(m.id));
  const missing = due.filter((m) => !filledIds.has(m.id));
  const ontrack = reports.filter((r) => r.status === "ontrack").length;
  const issues = reports.filter((r) => r.status !== "ontrack").length;
  const onLeave = data.team.filter((m) => m.mustReport && data.leaves.some((l) => l.memberId === m.id && l.from <= ds && ds <= l.to));
  const workday = data.settings.workDays.includes(new Date(`${ds}T00:00:00Z`).getUTCDay() || 7);
  const summary = !workday
    ? "Hari ini bukan hari kerja — tidak ada kewajiban lapor."
    : missing.length === 0 && due.length
      ? "Semua anggota wajib lapor sudah mengisi. Mantap!"
      : `${done.length} dari ${due.length} sudah mengisi${missing.length ? `, ${missing.length} belum` : ""}${issues ? `, ${issues} laporan Delay/Blocked perlu perhatian` : ""}.`;
  return (
    <Section id="status" eyebrow="Status Pengisian" title={isToday ? "Hari ini" : "Status tanggal terpilih"}>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Tile testid="tile-filled" accent label="Sudah mengisi" value={done.length} sub={`${done.length} dari ${due.length} anggota wajib lapor`} />
        <Tile testid="tile-missing" label="Belum mengisi" value={missing.length}
          sub={missing.length === 0 ? "lengkap" : beforeDeadline ? `batas ${dot(data.settings.deadline)} WIB` : "terlewat batas"} />
        <Tile testid="tile-ontrack" label="On track" value={ontrack} sub={reports.length ? `${Math.round((ontrack * 100) / reports.length)}% laporan` : "belum ada laporan"} />
        <Tile testid="tile-issues" label="Delay / Blocked" value={issues} sub={issues ? "perlu perhatian" : "aman"} />
      </div>
      <p data-testid="status-summary" className="mt-4 text-sm font-semibold">{summary}</p>
      <div className="mt-3 flex flex-wrap gap-2" data-testid="status-chips">
        {missing.map((m) => (
          <span key={m.id} data-testid={`chip-missing-${m.id}`} className="rounded-full bg-brand px-3 py-1 text-xs font-bold text-white">{m.name}</span>
        ))}
        {done.map((m) => (
          <span key={m.id} data-testid={`chip-done-${m.id}`} className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-bold text-emerald-800">{m.name}</span>
        ))}
        {onLeave.map((m) => (
          <span key={m.id} className="hatch rounded-full border border-brand-line px-3 py-1 text-xs font-bold text-[#7a6667]">{m.name} · cuti</span>
        ))}
      </div>
    </Section>
  );
}
